module.exports = __webpack_public_path__ + "src/assets/img/rampantcrime-fill.2d921949.jpg";